import { setLocale } from '../locales'

export default {
  computed: {
    currentLocale: {
      get() {
        return this.$i18n.locale
      },
      set(val) {
        return val
      }
    }
  },
  methods: {
    setLanguage(locale) {
      this.$i18n.locale = locale
      this.$vuetify.lang.current = locale
      setLocale(locale)
    }
  }
}
